import React from 'react';
import { FormError, HelpText } from '@Forms/fields.jsx';

import './PathField.scss';

export const PathField = ({
  className,
  error,
  helpText,
  label,
  name,
  pathPrefix,
  placeholder = '',
  register,
  options = {},
  type = 'text',
  ...props
}) => {
  // field for a page path
  return (
    <div
      className={
        `sb-form-item-formgroup sb-form-item-path ` +
        (error ? 'sb-form-item-error' : '') +
        ' ' +
        (className ? className : '')
      }
    >
      {label && <label htmlFor={name}>{label}</label>}
      <div className="sb-form-item-content sb-flex">
        <div className="sb-flex">
          {pathPrefix && (
            <p className="sb-form-inline-text sb-flex">{pathPrefix}</p>
          )}
          <input
            type={type}
            placeholder={placeholder}
            aria-invalid={error ? 'true' : 'false'}
            {...register(name, options)}
            {...props}
          />
        </div>
        {helpText && <HelpText message={helpText} />}
        {error && <FormError message={error.message} />}
      </div>
    </div>
  );
};
